var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader"},[_c('div',{staticClass:"loader-inner"},[(!_vm.hideLogo)?[(_vm.currentType == 'gant')?_c('spinner-gant'):_vm._e(),_vm._v(" "),(_vm.currentType == 'vermont')?_c('spinner-vermont'):_vm._e()]:_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }